import Client from "@/repositories/Client/AxiosClient.js"

const resource = `/api/cities`

export default {
  list(params = {}) {
    return Client.get(`${resource}`, { params })
  },
  get(cityId) {
    return Client.get(`${resource}/${cityId}`)
  },
  create(city) {
    return Client.post(`${resource}`, city)
  },
  update(cityId, city) {
    return Client.put(`${resource}/${cityId}`, city)
  },
  delete(cityId, params) {
    return Client.delete(`${resource}/${cityId}`, { data: params })
  },
  linkedAddresses(cityId) {
    return Client.get(`${resource}/${cityId}/addresses`)
  },
}
